import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useGameRequestStatus = (gameId: string | null) => {
  const [requestStatus, setRequestStatus] = useState<'none' | 'pending' | 'approved' | 'rejected'>('none');
  const [loading, setLoading] = useState(true);
  const { user, userType } = useAuth();

  useEffect(() => {
    if (!gameId || !user?.id) {
      setRequestStatus('none');
      setLoading(false);
      return;
    }

    const checkRequestStatus = async () => {
      try {
        // Pour creators et players, on cherche dans key_requests avec creator_id
        // (la table utilise creator_id même pour les players)
        const { data, error } = await supabase
          .from('key_requests')
          .select('status')
          .eq('game_id', gameId)
          .eq('creator_id', user.id)
          .single();

        if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
          console.error('Error checking request status:', error);
          setRequestStatus('none');
        } else if (data) {
          setRequestStatus(data.status);
        } else {
          setRequestStatus('none');
        }
      } catch (error) {
        console.error('Error:', error);
        setRequestStatus('none');
      } finally {
        setLoading(false);
      }
    };

    checkRequestStatus();
  }, [gameId, user?.id]);

  return { requestStatus, loading };
};
